// @mui

import {
  Grid,
  Card,
  Table,
  TableBody,
  TableContainer,
  TableCell,
  TableRow,
  Avatar,
  Box,
  Button,
  Paper,
  Stack,
  Typography,
  styled,
} from '@mui/material';
import { useNavigate } from 'react-router';
import { IContractInfoDetails } from 'src/@types/Choqorak/MainTables/Contract/ContractInfo';

import Iconify from 'src/components/Iconify';
import Label from 'src/components/Label';
import Image from 'src/components/Image';
// @types

//Localization
import useLocales from 'src/hooks/useLocales';
import { PATH_DASHBOARD } from 'src/routes/paths';
import { DateConverter } from 'src/sections/common/DateConverter';
import cssStyles from 'src/utils/cssStyles';

import { baseUrl } from 'src/api/baseUrl';
import { useStore } from 'src/stores/store';
import { useEffect, useState } from 'react';
import { IElectricityPayment } from 'src/@types/Choqorak/MainTables/ElectricityPayment/ElectricityPayment';
import { IRentPayment } from 'src/@types/Choqorak/MainTables/RentPayment.ts/RentPayment';
import HistoryComponent from '../../History/HistoryComponent';
import CalculateDuration from 'src/sections/common/CalculateDuration';

import DownloadIcon from '@mui/icons-material/Download';
import { GetCurrencySymbol } from 'src/sections/common/GetCurrencySymbol';
import MyDialog from 'src/components/MyDialog';
import ContractInfoDeleteAttachment from './ContractInfoDeleteAttachment';
import { observer } from 'mobx-react-lite';

// Props type definition
type Props = {
  row: IContractInfoDetails;
  clearContractInfo: () => void;
  electricityRow?: IElectricityPayment[];
  rentRow?: IRentPayment[];
  openAttachmentDialog: boolean;
};

export default observer(function ContractInfoDetailTableRow({
  row,
  clearContractInfo,
  electricityRow,
  rentRow,
  openAttachmentDialog,
}: Props) {
  const { translate } = useLocales();
  const { CustomerStore, ContractInfoStore } = useStore();
  const { loadCustomerDetail, SelectedCustomerDetail } = CustomerStore;
  const { setOpenCloseAttachmentDialogBox } = ContractInfoStore;
  const language = window.localStorage.getItem('i18nextLng');
  const navigate = useNavigate();
  useEffect(() => {
    loadCustomerDetail(row.customerId);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [row.customerId]);
  let Url = baseUrl;

  const [ContractInfoAttchId, setContractInfoAttachId] = useState<number>(0);

  const OverlayStyle = styled('div')(({ theme }) => ({
    ...cssStyles().bgBlur({ blur: 0.2, color: theme.palette.primary.darker }),
    top: 0,
    zIndex: 8,
    content: "''",
    width: '100%',
    height: '100%',
    position: 'absolute',
  }));
  const handleOpenDialog = (id?: number) => {
    console.log(id);
    setContractInfoAttachId(id!);
    setOpenCloseAttachmentDialogBox();
  };
  const handleCloseDialog = () => {
    setOpenCloseAttachmentDialogBox();
  };

  return (
    <>
      <Grid item xs={6} md={6}>
        <Stack direction="row" spacing={1.5} sx={{ mt: 1, ml: 0, mb: 2 }}>
          <Button
            variant="contained"
            color="error"
            size="small"
            startIcon={<Iconify icon="eva:arrow-ios-back-fill" />}
            onClick={() => {
              navigate(PATH_DASHBOARD.ContractInfo.list);
              // clearCustomer();
            }}
          >
            {translate('CRUD.BackToList')}
          </Button>
        </Stack>
      </Grid>

      <Grid container spacing={3}>
        <Grid item xs={12} md={4}>
          <Card sx={{ py: 2, px: 2 }}>
            <Card sx={{ textAlign: 'center' }}>
              <Box sx={{ position: 'relative' }}>
                <Avatar
                  alt={SelectedCustomerDetail?.photoPath}
                  src={Url + SelectedCustomerDetail?.photoPath}
                  sx={{
                    width: 90,
                    height: 90,
                    zIndex: 11,
                    left: 0,
                    right: 0,
                    bottom: -32,
                    mx: 'auto',
                    position: 'absolute',
                  }}
                />
                <OverlayStyle />
                <Image src={require('src/assets/images/dam.jpg')} alt="" ratio="16/9" />
              </Box>

              <Typography variant="subtitle1" sx={{ mt: 6 }}>
                {language === 'en'
                  ? SelectedCustomerDetail?.englishFirstName +
                    ' ' +
                    SelectedCustomerDetail?.englishSurName
                  : SelectedCustomerDetail?.pashtoFirstName +
                    ' ' +
                    SelectedCustomerDetail?.pashtoSurName}
              </Typography>

              <Stack alignItems="center">
                <Typography variant="body2" sx={{ color: 'text.secondary', my: 2.5 }}>
                  {SelectedCustomerDetail?.bloodGroup}
                </Typography>
              </Stack>
            </Card>
          </Card>
        </Grid>
        <Grid item xs={12} md={8}>
          <Card sx={{ minWidth: 275, borderRadius: '15px' }}>
            <Typography
              variant="h5"
              sx={{ fontSize: 14, textAlign: 'left', mb: 2, mt: 2, ml: 3, color: 'warning.main' }}
              color="text.secondary"
              gutterBottom
            >
              <Label
                variant="ghost"
                sx={{ textTransform: 'capitalize', fontSize: 17, p: 2 }}
                color="warning"
              >
                {translate('Customer.CustomerGeneralInfos')}
              </Label>
            </Typography>

            <TableContainer component={Paper} sx={{ p: 2 }}>
              <Table size="medium">
                <TableBody>
                  {[
                    {
                      label: translate('Customer.FatherName'),
                      value:
                        language === 'en'
                          ? SelectedCustomerDetail?.englishFatherName
                          : SelectedCustomerDetail?.pashtoFatherName,
                    },
                    {
                      label: translate('Customer.GrandFatherName'),
                      value:
                        language === 'en'
                          ? SelectedCustomerDetail?.englishGrandFatherName
                          : SelectedCustomerDetail?.pashtoGrandFatherName,
                    },
                    {
                      label: translate('Customer.DateOfBirth'),
                      value: <DateConverter date={SelectedCustomerDetail?.dateOfBirth} />,
                    },
                    {
                      label: translate('Customer.PersonalEmail'),
                      value: SelectedCustomerDetail?.personalEmail,
                    },
                    {
                      label: translate('Customer.PhoneNumber'),
                      value: SelectedCustomerDetail?.phoneNumber,
                    },
                    { label: translate('Customer.CNIC'), value: SelectedCustomerDetail?.tazkiraNo },
                  ].map((item, index) => (
                    <TableRow key={index}>
                      <TableCell
                        sx={{ fontWeight: 'bold', color: 'text.disabled', fontSize: '14px' }}
                      >
                        {item.label}:
                      </TableCell>
                      <TableCell sx={{ fontSize: '14px' }}>{item.value}</TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          </Card>
        </Grid>

        {/* <Divider sx={{ borderStyle: 'dashed' }} /> */}
        {/* sx={{ mt: 2, mr: 2, ml: 2, mb: 2 }} */}

        <Grid item xs={12} md={12}>
          <Card sx={{ p: 2 }}>
            <Typography
              variant="h5"
              sx={{ fontSize: 14, textAlign: 'center', mb: 2, color: 'warning.main' }}
              color="text.secondary"
              gutterBottom
            >
              <Label
                variant="ghost"
                sx={{ textTransform: 'capitalize', fontSize: 15, p: 2 }}
                color="warning"
              >
                {translate('contractsInfo.Title')}
              </Label>
            </Typography>
            <TableContainer component={Paper}>
              <Table sx={{ minWidth: '100%' }} size="small" aria-label="a dense table">
                {/* <caption>A basic table example with a caption</caption> */}
                <TableBody>
                  <TableRow sx={{ borderBottom: '1px solid rgba(60,60,60,.9)' }}>
                    <TableCell
                      align="left"
                      sx={{
                        fontWeight: 'bold',
                        color: 'info.main',
                        fontSize: '16px',
                      }}
                    >
                      {translate('Shop.ShopCode')}
                    </TableCell>
                    <TableCell align="left">{row.shopCode}</TableCell>

                    <TableCell
                      align="left"
                      sx={{
                        fontWeight: 'bold',
                        color: 'info.main',
                        fontSize: '16px',
                      }}
                    >
                      {translate('Floor.FloorCode')}
                    </TableCell>
                    <TableCell align="left">{row.floorCode}</TableCell>
                    <TableCell
                      align="left"
                      sx={{
                        fontWeight: 'bold',
                        color: 'info.main',
                        fontSize: '16px',
                      }}
                    >
                      {translate('Block.BlockName')}
                    </TableCell>
                    <TableCell align="left">{row.blockName}</TableCell>
                  </TableRow>
                  <TableRow sx={{ borderBottom: '1px solid rgba(60,60,60,.9)' }}>
                    <TableCell
                      align="left"
                      sx={{
                        fontWeight: 'bold',
                        color: 'info.main',
                        fontSize: '16px',
                      }}
                    >
                      {translate('contractsInfo.ContractNumber')}
                    </TableCell>
                    <TableCell align="left">{row.contractNumber}</TableCell>

                    <TableCell
                      align="left"
                      sx={{
                        fontWeight: 'bold',
                        color: 'info.main',
                        fontSize: '16px',
                      }}
                    >
                      {translate('contractsInfo.ContractCreator')}
                    </TableCell>
                    <TableCell align="left">
                      {language === 'en'
                        ? row?.contractCreatorEnglishName
                        : row?.contractCreatorPashtoName}
                    </TableCell>
                    <TableCell
                      align="left"
                      sx={{
                        fontWeight: 'bold',
                        color: 'info.main',
                        fontSize: '16px',
                      }}
                    >
                      {translate('ContractType.ContractType')}
                    </TableCell>
                    <TableCell align="left">{row.contractType}</TableCell>
                  </TableRow>
                  <TableRow sx={{ borderBottom: '1px solid rgba(60,60,60,.9)' }}>
                    <TableCell
                      align="left"
                      sx={{
                        fontWeight: 'bold',
                        color: 'info.main',
                        fontSize: '16px',
                      }}
                    >
                      {translate('Shop.RentPerMonth')}
                    </TableCell>
                    <TableCell align="left">
                      {row.finalRentPerMonth}{' '}
                      {row.rentCarrencyId === 2
                        ? GetCurrencySymbol('afn')
                        : GetCurrencySymbol('dollar')}
                    </TableCell>
                    <TableCell
                      align="left"
                      sx={{
                        fontWeight: 'bold',
                        color: 'info.main',
                        fontSize: '16px',
                      }}
                    >
                      {translate('contractsInfo.TotalContractDurationRent')}
                    </TableCell>
                    <TableCell align="left">{Math.floor(row.totalContractDurationRent!)}</TableCell>
                    <TableCell
                      align="left"
                      sx={{
                        fontWeight: 'bold',
                        color: 'info.main',
                        fontSize: '16px',
                      }}
                    >
                      {translate('contractsInfo.TotalContractDurationPaidRent')}
                    </TableCell>
                    <TableCell align="left">{row.totalContractDurationPaidRent}</TableCell>
                  </TableRow>
                  <TableRow sx={{ borderBottom: '1px solid rgba(60,60,60,.9)' }}>
                    <TableCell
                      align="left"
                      sx={{
                        fontWeight: 'bold',
                        color: 'info.main',
                        fontSize: '16px',
                      }}
                    >
                      {translate('contractsInfo.StartDate')}
                    </TableCell>
                    <TableCell align="left">
                      {<DateConverter date={row.contractStartDate} />}
                    </TableCell>
                    <TableCell
                      align="left"
                      sx={{
                        fontWeight: 'bold',
                        color: 'info.main',
                        fontSize: '16px',
                      }}
                    >
                      {translate('contractsInfo.EndDate')}
                    </TableCell>
                    <TableCell align="left">
                      {<DateConverter date={row.contractEndDate} />}
                    </TableCell>
                    <TableCell
                      align="left"
                      sx={{
                        fontWeight: 'bold',
                        color: 'info.main',
                        fontSize: '16px',
                      }}
                    >
                      {translate('contractsInfo.ContractDuration')}
                    </TableCell>
                    <TableCell align="left">
                      {/* {CalculateDuration(translate, row.contractStartDate, row.contractEndDate)} */}
                      {row.contractDuration}
                    </TableCell>
                  </TableRow>
                  {row.discountStartDate || row.discountEndDate ? (
                    <>
                      <TableRow sx={{ borderBottom: '1px solid rgba(60,60,60,.9)' }}>
                        <TableCell
                          align="left"
                          sx={{
                            fontWeight: 'bold',
                            color: 'info.main',
                            fontSize: '16px',
                          }}
                        >
                          {translate('contractsInfo.DiscountStartDate')}
                        </TableCell>
                        <TableCell align="left">
                          {<DateConverter date={row.discountStartDate} />}
                        </TableCell>

                        <TableCell
                          align="left"
                          sx={{
                            fontWeight: 'bold',
                            color: 'info.main',
                            fontSize: '16px',
                          }}
                        >
                          {translate('contractsInfo.DiscountEndDate')}
                        </TableCell>
                        <TableCell align="left">
                          {<DateConverter date={row.discountEndDate} />}
                        </TableCell>

                        <TableCell
                          align="left"
                          sx={{
                            fontWeight: 'bold',
                            color: 'info.main',
                            fontSize: '16px',
                          }}
                        >
                          {translate('contractsInfo.DurationOfDiscount')}
                        </TableCell>
                        <TableCell align="left">
                          {CalculateDuration(translate, row.discountStartDate, row.discountEndDate)}
                        </TableCell>
                      </TableRow>
                      <TableRow sx={{ borderBottom: '1px solid rgba(60,60,60,.9)' }}>
                        <TableCell
                          align="left"
                          sx={{
                            fontWeight: 'bold',
                            color: 'info.main',
                            fontSize: '16px',
                          }}
                        >
                          {translate('contractsInfo.NeedApproval')}
                        </TableCell>
                        <TableCell align="left">
                          {row.needApproval && !row.isApproved
                            ? translate('contractsInfo.NeedApproval')
                            : translate('contractsInfo.Approveds')}
                        </TableCell>

                        <TableCell
                          align="left"
                          sx={{
                            fontWeight: 'bold',
                            color: 'info.main',
                            fontSize: '16px',
                          }}
                        >
                          {translate('contractsInfo.IsApproved')}
                        </TableCell>
                        <TableCell align="left">
                          {row.isApproved
                            ? translate('contractsInfo.Approveds')
                            : translate('contractsInfo.NotApproved')}
                        </TableCell>

                        <TableCell
                          align="left"
                          sx={{
                            fontWeight: 'bold',
                            color: 'info.main',
                            fontSize: '16px',
                          }}
                        >
                          {translate('contractsInfo.ApprovedBy')}
                        </TableCell>
                        <TableCell align="left">{row.approvedByName}</TableCell>
                      </TableRow>
                    </>
                  ) : (
                    ''
                  )}
                  {row.advancePayment ? (
                    <TableRow sx={{ borderBottom: '1px solid rgba(60,60,60,.9)' }}>
                      <TableCell
                        align="left"
                        sx={{
                          fontWeight: 'bold',
                          color: 'info.main',
                          fontSize: '16px',
                        }}
                      >
                        {translate('contractsInfo.AdvancePayment')}
                      </TableCell>
                      <TableCell align="left">
                        {row.advancePayment}
                        {row.rentCarrencyId === 2
                          ? GetCurrencySymbol('afn')
                          : GetCurrencySymbol('dollar')}
                      </TableCell>

                      <TableCell
                        align="left"
                        sx={{
                          fontWeight: 'bold',
                          color: 'info.main',
                          fontSize: '16px',
                        }}
                      >
                        {translate('contractsInfo.AdvanceRecievedByUserName')}
                      </TableCell>
                      <TableCell align="left">{row.advanceRecievedByUserName}</TableCell>

                      <TableCell
                        align="left"
                        sx={{
                          fontWeight: 'bold',
                          color: 'info.main',
                          fontSize: '16px',
                        }}
                      >
                        {translate('contractsInfo.Status')}
                      </TableCell>
                      <TableCell align="left">{row.contractStatus}</TableCell>
                    </TableRow>
                  ) : (
                    ''
                  )}

                  <TableRow sx={{ borderBottom: '1px solid rgba(60,60,60,.9)' }}>
                    <TableCell
                      align="left"
                      sx={{
                        fontWeight: 'bold',
                        color: 'info.main',
                        fontSize: '16px',
                      }}
                    >
                      {translate('contractsInfo.Terminated')}
                    </TableCell>
                    <TableCell align="left">
                      {row.isTerminated === true
                        ? `${translate('contractsInfo.Terminated')}`
                        : `${translate('contractsInfo.NotTerminated')}`}
                    </TableCell>
                  </TableRow>
                </TableBody>
              </Table>
            </TableContainer>
          </Card>
        </Grid>
        {row.isTerminated ? (
          <Grid item xs={12} md={12}>
            <Card sx={{ p: 2 }}>
              <Typography
                variant="h5"
                sx={{ fontSize: 14, textAlign: 'center', mb: 2, color: 'warning.main' }}
                color="text.secondary"
                gutterBottom
              >
                <Label
                  variant="ghost"
                  sx={{ textTransform: 'capitalize', fontSize: 15, p: 2 }}
                  color="warning"
                >
                  {translate('Terminate.TerminatedInfo')}
                </Label>
              </Typography>
              <TableContainer component={Paper}>
                <Table sx={{ minWidth: '100%' }} size="small" aria-label="a dense table">
                  {/* <caption>A basic table example with a caption</caption> */}
                  <TableBody>
                    <TableRow sx={{ borderBottom: '1px solid rgba(60,60,60,.9)' }}>
                      <TableCell
                        align="left"
                        sx={{
                          fontWeight: 'bold',
                          color: 'info.main',
                          fontSize: '16px',
                        }}
                      >
                        {translate('Terminate.TerminationDate')}
                      </TableCell>
                      <TableCell align="left">
                        {<DateConverter date={row.terminationDate} />}
                      </TableCell>

                      <TableCell
                        align="left"
                        sx={{
                          fontWeight: 'bold',
                          color: 'info.main',
                          fontSize: '16px',
                        }}
                      >
                        {translate('Terminate.TerminationDescription')}
                      </TableCell>
                      <TableCell align="left">{row.terminationDescription}</TableCell>
                    </TableRow>

                    <TableRow sx={{ borderBottom: '1px solid rgba(60,60,60,.9)' }}>
                      <TableCell
                        align="left"
                        sx={{
                          fontWeight: 'bold',
                          color: 'info.main',
                          fontSize: '16px',
                        }}
                      >
                        {translate('Terminate.DeductedAmountFromAdvancePayment')}
                      </TableCell>
                      <TableCell align="left">{row.deductedAmountFromAdvancePayment}</TableCell>

                      <TableCell
                        align="left"
                        sx={{
                          fontWeight: 'bold',
                          color: 'info.main',
                          fontSize: '16px',
                        }}
                      >
                        {translate('Terminate.DeductionDescription')}
                      </TableCell>
                      <TableCell align="left">{row.deductionDescription}</TableCell>
                    </TableRow>

                    <TableRow sx={{ borderBottom: '1px solid rgba(60,60,60,.9)' }}>
                      <TableCell
                        align="left"
                        sx={{
                          fontWeight: 'bold',
                          color: 'info.main',
                          fontSize: '16px',
                        }}
                      >
                        {translate('Terminate.ManuallyPaidAmount')}
                      </TableCell>
                      <TableCell align="left">{row.manuallyPaidAmount}</TableCell>

                      <TableCell
                        align="left"
                        sx={{
                          fontWeight: 'bold',
                          color: 'info.main',
                          fontSize: '16px',
                        }}
                      >
                        {translate('Terminate.RemainAmount')}
                      </TableCell>
                      <TableCell align="left">{row.remainAmount}</TableCell>
                    </TableRow>
                  </TableBody>
                </Table>
              </TableContainer>
            </Card>
          </Grid>
        ) : (
          ''
        )}
        {row.attachmentFiles ? (
          <Grid item xs={12} md={12}>
            <Card sx={{ p: 2 }}>
              <Typography
                variant="h5"
                sx={{ fontSize: 14, textAlign: 'center', mb: 2, color: 'warning.main' }}
                color="text.secondary"
                gutterBottom
              >
                <Label
                  variant="ghost"
                  sx={{ textTransform: 'capitalize', fontSize: 15, p: 2 }}
                  color="warning"
                >
                  {translate('contractsInfo.Attachments')}
                </Label>
              </Typography>
              <TableContainer component={Paper}>
                <Table sx={{ minWidth: '100%' }} size="small" aria-label="a dense table">
                  {/* <caption>A basic table example with a caption</caption> */}
                  <TableBody>
                    {row.attachmentFiles?.map((file, index) => (
                      <TableRow key={index}>
                        <TableCell>{file.fileName}</TableCell>
                        <TableCell>
                          {/* Link Icon that opens the PDF in a new tab for viewing */}
                          <a href={Url! + file.path} target="_blank" rel="noopener noreferrer">
                            <DownloadIcon />
                          </a>
                        </TableCell>
                        <TableCell>
                          <Iconify
                            icon={'eva:trash-2-outline'}
                            style={{ cursor: 'pointer', color: 'red' }}
                            onClick={() => handleOpenDialog(file.attachmentId)}
                          />
                        </TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>
            </Card>
          </Grid>
        ) : (
          ''
        )}
      </Grid>

      <MyDialog
        open={openAttachmentDialog}
        onClose={handleCloseDialog}
        title={translate('CRUD.DeleteTitle')}
        size="md"
      >
        <ContractInfoDeleteAttachment id={ContractInfoAttchId} ContractId={row.contractId} />
      </MyDialog>

      {/* <Grid item xs={12} md={12} sx={{ mt: 2 }}>
        <Card sx={{ borderRadius: 2, boxShadow: 3 }}>
          <CardHeader
            title={`${translate('contractsInfo.contractDetails')}`}
            sx={{ mb: 2, fontWeight: 'bold', fontSize: '1.2rem' }}
          />

          <Scrollbar>
            <TableContainer sx={{ minWidth: 720 }}>
              <Table>
             
                <TableHeadCustom headLabel={TABLE_HEAD} />
              </Table>
            </TableContainer>
          </Scrollbar>

          <Divider sx={{ borderColor: 'grey.700' }} />
        </Card>
      </Grid> */}
      <HistoryComponent
        electricityRow={electricityRow}
        rentRow={rentRow}
        historyTitle={translate('contractsInfo.Title')}
      />
    </>
  );
});
